/**
 *
 * MultiInput
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash-es';
import { Form } from 'react-bootstrap';
import { useIntl } from 'react-intl';

function MultiInput(props) {
  const { items, value, onChange } = props;
  const intl = useIntl();

  if (!value) {
    return null;
  }
  const handleChange = (key) => (ev) => onChange({ ...value, [key]: ev.target.value });

  return items.map((item) => (
    <Form.Control
      id={item.id}
      key={item.id}
      type={item.type || 'text'}
      className="form-control"
      placeholder={intl.formatMessage(item.label)}
      value={value[item.id] === undefined || value[item.id] === null ? '' : value[item.id]}
      onChange={handleChange(item.id)}
      {...item.attributes}
    />
  ));
}

MultiInput.propTypes = {
  items: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};

MultiInput.itemToString = (keys) => (item) => keys.map((key) => item[key]).filter((v) => Boolean(v)).join(' ');
MultiInput.isEmpty = (keys) => (item) => keys.every((key) => isEmpty(item[key]));

export default MultiInput;
